import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import axios from "../../../services/axiosInstance";
import useTheme from "../../../components/web/layoutscommon/DarkModeStorage";
import StoreTermsPopup from "./StoreTermsPopup";
import StoreAuthShell from "./StoreAuthShell";
import {Btn, ErrorText, Field} from "./StoreUI";
import {TbMailFast} from "react-icons/tb";

/**
 * 상점사(쇼핑몰) 비밀번호 찾기
 *  - 경로 : /store/api/findpw
 *  - 가입된 이메일로 임시비밀번호를 발송한다(자동메일).
 */
function StoreFindPwPg() {

    const [theme] = useTheme();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [errorMsg, setErrorMsg] = useState('');
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const [termsOfUsePopup, setTermsOfUsePopup] = useState(false);
    const [privacyPolicyPopup, setPrivacyPolicyPopup] = useState(false);

    const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    const handleSend = async () => {
        if (loading) return;
        setErrorMsg('');

        if (!EMAIL_REGEX.test(email)) {
            setErrorMsg('올바른 이메일 형식이 아닙니다');
            return;
        }

        setLoading(true);
        try {
            await axios.post('/store/generateTempPassword', null, {params: {email: email.trim()}});
            setSent(true);
        } catch (e) {
            setErrorMsg(e?.response?.data?.message || '가입되지 않은 이메일이거나 발송에 실패했습니다');
        } finally {
            setLoading(false);
        }
    };

    return (
        <StoreAuthShell theme={theme}
                        title={sent ? "메일을 보냈습니다" : "비밀번호 찾기"}
                        desc={sent ? null : "가입하신 이메일로 임시비밀번호를 보내드립니다"}
                        onTerms={() => setTermsOfUsePopup(true)}
                        onPrivacy={() => setPrivacyPolicyPopup(true)}>

            {sent ? (
                <div className="tw-text-center">
                    {/* 발송 완료 — 여명 오브 안에 편지 아이콘 */}
                    <div className="tw-relative tw-mx-auto tw-mb-6 tw-flex tw-h-[78px] tw-w-[78px] tw-items-center tw-justify-center">
                        <span aria-hidden="true" className="tw-absolute tw-inset-0 tw-rounded-full tw-animate-breathe"
                              style={{background: 'radial-gradient(circle at 36% 32%, rgba(255,190,72,.55), rgba(203,182,255,.32) 60%, transparent 72%)'}}/>
                        <TbMailFast className="tw-relative tw-text-[32px] tw-text-[#B8790F]"/>
                    </div>

                    <p className="tw-text-[13px] tw-leading-[1.9] tw-text-[color:var(--st-text-sub)] tw-break-keep">
                        <b className="st-mono tw-text-[color:var(--st-text)]">{email.trim()}</b> 로<br/>
                        임시비밀번호를 보냈습니다. 메일함을 확인해주세요.
                    </p>
                    <p className="tw-mx-auto tw-mt-3 tw-max-w-[320px] tw-text-[12px] tw-leading-[1.8] tw-text-[color:var(--st-text-faint)] tw-break-keep">
                        로그인하신 뒤 [내정보] 에서 새 비밀번호로 바꿔주세요.
                    </p>

                    <Btn tone="dawn" size="lg" className="tw-mt-7 tw-w-full" onClick={() => navigate('/store/api/login')}>
                        로그인하러 가기
                    </Btn>
                </div>
            ) : (
                <>
                    <Field label="가입 이메일">
                        <input className="st-input" type="text" value={email} maxLength={50}
                               placeholder="example@company.com"
                               onChange={(e) => setEmail(e.target.value)}
                               onKeyDown={(e) => e.key === 'Enter' && handleSend()}/>
                    </Field>

                    {errorMsg ? <ErrorText>{errorMsg}</ErrorText> : null}

                    <Btn tone="dawn" size="lg" className="tw-mt-4 tw-w-full" onClick={handleSend}
                         disabled={loading} busy={loading}>
                        임시비밀번호 받기
                    </Btn>

                    <div className="tw-mt-5 tw-text-center tw-text-[13px]">
                        <button type="button" className="st-link" onClick={() => navigate('/store/api/login')}>
                            로그인으로 돌아가기
                        </button>
                    </div>
                </>
            )}

            {termsOfUsePopup ?
                <StoreTermsPopup termsOfUsePopup={termsOfUsePopup} closeTermsPopup={() => setTermsOfUsePopup(false)}/>
                : null}
            {privacyPolicyPopup ?
                <StoreTermsPopup privacyPolicyPopup={privacyPolicyPopup} closeTermsPopup={() => setPrivacyPolicyPopup(false)}/>
                : null}
        </StoreAuthShell>
    );
}

export default StoreFindPwPg;
